import React, { Component } from "react";
import LoadingOverlay from 'react-loading-overlay';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import "./DeleteProductImage.scss";
import { connect } from "react-redux";
import { DeleteImage, GetProductsWithImages } from "../../../../../actions/ProductActions"
import { GET_ERRORS } from "../../../../../actions/types";
import FindProductImage from "./FindProductImage";
import ImageList from '@material-ui/core/ImageList';
import ImageListItem from '@material-ui/core/ImageListItem';
import ImageListItemBar from '@material-ui/core/ImageListItemBar';
import IconButton from '@material-ui/core/IconButton';
import HighlightOff from '@material-ui/icons/HighlightOff';
import DialogDelete from "../../../../common/Dialog";
import { Col } from "react-bootstrap";

import noAvailable from "../../../../../img/noAvailable.png";

// Dialog
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

// Snack bar
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
function Alert(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}



class DeleteProductImage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeLoader: false,
			isVisible: true,
			modal: false,
			type: null,
			message: null,
			title: null,
			// resolution flag
			resolution900x900: true,
			// snack
			showSnackBar: false,
			textSnackBar: '',
			severitySnackBar: 'success',
			// dialog
			showDeleteImageDialog: false,
			imageToDeleteText: ''
		};

		this.onOpenDialogWarning = this.onOpenDialogWarning.bind(this);
		this.onCloseDialog = this.onCloseDialog.bind(this);
		this.onDropImage = this.onDropImage.bind(this);
		this.setDefault = this.setDefault.bind(this);
		this.handleOpenDeleteImageDialog = this.handleOpenDeleteImageDialog.bind(this);
		this.handleCloseDeleteImageDialog = this.handleCloseDeleteImageDialog.bind(this);

	}

	componentDidMount() { }

	componentDidUpdate(prevProps) {
		if (prevProps.product_reducer.alreadyImages !== null && prevProps.product_reducer.alreadyImages !== this.props.product_reducer.alreadyImages) {
			this.setState(
				{ activeLoader: false }
			)
		}

		if (prevProps.product_reducer.deleteOk !== this.props.product_reducer.deleteOk && this.props.product_reducer.deleteOk) {
			this.setState({
				isVisible: true,
				showSnackBar: true,
				textSnackBar: this.props.product_reducer.success,
				severitySnackBar: 'success',
			}, () => {
				this.props.product_reducer.success = null;
				this.props.product_reducer.deleteOk = false;
			});
		}
		if (this.props.actionType === GET_ERRORS && prevProps.actionType !== GET_ERRORS) {
			this.setState({
				isVisible: true,
				showSnackBar: true,
				textSnackBar: this.props.product_reducer.message,
				severitySnackBar: 'warning',
				activeLoader: false
			});
		}
	}

	getProducts(sap, resolution) {
		this.props.GetProductsWithImages(sap, resolution);
		this.setState({
			activeLoader: true,
			isVisible: false
		})
	}

	setDefault(e) {
		e.target.src = noAvailable
	}

	onDropImage = (id) => {

		let url = `${this.state.id}&resolution=${this.state.resolution900x900 ? '900x900' : '300x300'}&user_id=${localStorage.getItem('user_id')}`
		if (this.state.resolution900x900) {
			url = url = '?name=' + url.replace('https://images-product.s3.amazonaws.com/', '');
		} else {
			url = url = '?name=' + url.replace('https://image-product-300x300.s3.amazonaws.com/', '');
		}
		this.setState(
			{
				id: null,
				modal: false,
				type: null,
				message: null,
				title: null,
				showDeleteImageDialog: false,
				imageToDeleteText: ''
			},
			() => this.props.DeleteImage(url)
		);
	}

	onOpenDialogWarning(id) {
		this.setState(
			{
				id: id,
				modal: true,
				type: "warning",
				message: "¿Seguro que desea eliminar esta imagen? Esta acción es irreversible",
				title: "¡Advertencia!"
			}
		)
	}

	onCloseDialog() {
		this.setState({
			id: null,
			modal: false,
			type: null,
			message: null,
			title: null
		})
	}

	getListOfImages(images) {
		let imgs = [];
		for (const image of images) {
			let key = Object.keys(image);
			let imgNum = key[0].match(/\d+/)[0];
			let regex;
			if (this.state.resolution900x900) {
				regex = new RegExp("^https://images-product.s3.amazonaws.com/([^&#]*)")
			} else {
				regex = new RegExp("^https://image-product-300x300.s3.amazonaws.com/([^&#]*)")
			}
			let results = regex.exec(image[key[0]]);
			let sap = results[1].split("_");
			let title = "Imagen " + imgNum
			let img =
				<ImageListItem key={imgNum} style={{ width: "25%" }}>
					<img src={image[key[0]]}
						style={{ objectFit: "cover" }}
						alt={sap[0]}
						onError={this.setDefault}
						id={image[key[0]]} />
					<ImageListItemBar
						title={title}
						className="image-title image-tittle-bar"
						actionIcon={
							<IconButton onClick={() => this.handleOpenDeleteImageDialog(image[key[0]], title)} style={{ color: "white" }} aria-label={`star ${title}`}>
								<HighlightOff className="image-title" />
							</IconButton>
						}
					/>
				</ImageListItem>
			imgs.push(img)
		}
		return (
			<div className="root-image">
				<ImageList className="imageList" cols={2.5}>
					{imgs}
				</ImageList>
			</div>
		)
	}

	handleResolution(resolutionFlag) {
		this.setState({
			resolution900x900: resolutionFlag,
		});
	}

	handleCloseSnack = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		this.setState({
			showSnackBar: false
		})
	}

	handleCloseDeleteImageDialog() {
		// new
		this.setState({
			showDeleteImageDialog: false
		});
	}

	handleOpenDeleteImageDialog(id, text) {
		this.setState(
			{
				id: id,
				showDeleteImageDialog: true,
				imageToDeleteText: text
			}
		)
	}

	render() {
		const columns = [
			{
				dataField: 'no_sap',
				text: 'No SAP',
				headerStyle: () => {
					return { width: "5%" };
				},
			},
			{
				dataField: 'images',
				text: 'Imágenes',
				headerStyle: () => {
					return { width: "40%" };
				},
				formatter: (images) => {
					if (images) {
						let cell = this.getListOfImages(images)
						return <center>{cell}</center>
					}
					else
						return ""
				},
			},

		];
		let { product_reducer } = this.props;
		if (!product_reducer.alreadyImages)
			product_reducer.alreadyImages = [];

		const customOptions = {
			noDataText: '<div className="color-red">No se encontro el nosap indicado. Vuelve a intentar</div>'
		};

		return (
			<center>
				<div style={{ display: "flex", flexDirection: "column", position: "relative" }}>
					<Col xs={12} md={12} sm={12} lg={12} style={{ marginTop: '3vh' }}>
						<h4 style={{ color: '#164289', 'fontWeight': 'bold' }}>Tamaño de imagenes</h4>
						<div>
							<input
								type="radio"
								style={{ cursor: 'pointer' }}
								checked={this.state.resolution900x900}
								onChange={() => { this.handleResolution(true) }} />
							<span style={{ color: '#164289', fontSize: '1.2rem' }}> 900 x 900</span>
							&nbsp;&nbsp;&nbsp;
							<input
								type="radio"
								style={{ cursor: 'pointer' }}
								checked={!this.state.resolution900x900}
								onChange={() => { this.handleResolution(false) }}
							/>
							<span style={{ color: '#164289', fontSize: '1.2rem' }}> 300 x 300</span>
						</div>
					</Col>

					<FindProductImage
						resolution900x900={this.state.resolution900x900}
						GetProductsWithImages={this.getProducts.bind(this)}
					/>
					<div className="user-category-wrapper" style={{ display: !this.state.isVisible ? "block" : "none" }}>
						{
							product_reducer.alreadyImages.length === 0 ?
								<h2>No se encontro el no sap</h2> :
								<ToolkitProvider
									keyField="no_sap"
									data={product_reducer.alreadyImages}
									columns={columns}
								>
									{
										props => (
											<div style={{ textAlign: "left", height: "40vh", overflow: "auto", width: "100%" }}>
												<BootstrapTable
													striped
													hover
													opt
													condensed
													options={customOptions}
													headerWrapperClasses="title-table"
													{...props.baseProps}
												/>
											</div>
										)
									}
								</ToolkitProvider>
						}

					</div>
					{
						this.state.modal &&
						<DialogDelete
							handleDelete={this.onDropImage}
							id={this.state.id}
							handleClose={this.onCloseDialog}
							open={this.state.modal}
							title={this.state.title}
							message={this.state.message}
							type={this.state.type}

						/>
					}
					<LoadingOverlay
						active={this.state.activeLoader}
						isVisible={this.state.activeLoader}
						spinner
						text='Esto puede tardar unos minutos'
						styles={{
							wrapper: {
								width: this.state.activeLoader ? '100%' : '0%',
								height: this.state.activeLoader ? '100%' : '0%',
								overflow: 'hidden',
							},
							overlay: (base) => ({
								...base,
								background: 'rgba(10, 10, 10, 0.7)'
							})
						}}>
					</LoadingOverlay>
					{
						<Snackbar
							open={this.state.showSnackBar}
							autoHideDuration={6000}
							onClose={this.handleCloseSnack}>
							<Alert
								onClose={this.handleCloseSnack}
								severity={this.state.severitySnackBar}>
								{this.state.textSnackBar}
							</Alert>
						</Snackbar>
					}
					{
						<Dialog
							open={this.state.showDeleteImageDialog}
							onClose={this.handleCloseDeleteImageDialog}
							aria-labelledby="alert-dialog-title"
							aria-describedby="alert-dialog-description"
						>
							<DialogTitle id="alert-dialog-title">{"Eliminar imagen"}</DialogTitle>
							<DialogContent>
								<DialogContentText id="alert-dialog-description">
									¿Seguro que deseas eliminar la imagen?  *{this.state.imageToDeleteText}
								</DialogContentText>
							</DialogContent>
							<DialogActions>
								<Button onClick={this.handleCloseDeleteImageDialog} color="secondary">
									Cancelar
								</Button>
								<Button onClick={this.onDropImage} color="primary" autoFocus>
									Eliminar
								</Button>
							</DialogActions>
						</Dialog>
					}
				</div>
			</center>
		)
	}

}

const mapStateToProps = state => ({
	actionType: state.product_reducer.actionType,
	product_reducer: state.product_reducer,
	errors: state.errors,
	success: state.success
});

export default connect(
	mapStateToProps,
	{
		DeleteImage,
		GetProductsWithImages
	}
)(DeleteProductImage);